module.exports = __webpack_public_path__ + "img/INT-1440.c797a4c5.jpg";